import * as types from '../../constants/rmg/CategoryActionTypes'
import produce from 'immer'
import _ from 'lodash';

const initialState = {
    categories: null,
    selected: null,
    loading: false
};

const request = (state, selectedId) => produce(state, draft => {
    draft.selected = selectedId;
    draft.categories = null;
    draft.loading = true;
});

const receive = (state, selectedId, data) => produce(state, draft => {
        draft.selected = selectedId;
        draft.categories = data;
        draft.loading = false;
});

export default function reduce (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST:
        return request(state, action.id)
    case types.RECEIVE:
        return receive(state, action.id, action.data);
    default:
      return state
  }
}
